import React, { useState, useEffect } from 'react';
import { workersAPI } from '../services/api';

export default function WorkersManagement() {
  const [allWorkers, setAllWorkers] = useState([]);
  const [pendingWorkers, setPendingWorkers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('all');
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: '', phone: '', password: '', nationalId: '', vehicleType: '', vehiclePlate: '',
  });
  const [formError, setFormError] = useState('');
  const [formLoading, setFormLoading] = useState(false);

  useEffect(() => {
    loadAll();
  }, []);

  const loadAll = async () => {
    try {
      const [allRes, pendingRes] = await Promise.all([
        workersAPI.getAll(),
        workersAPI.getPending(),
      ]);
      setAllWorkers(allRes.data.workers);
      setPendingWorkers(pendingRes.data.workers);
    } catch (error) {
      console.log('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (id) => {
    try {
      await workersAPI.approve(id);
      loadAll();
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const handleReject = async (id) => {
    try {
      await workersAPI.reject(id);
      loadAll();
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    setFormError('');
    if (!formData.name || !formData.phone || !formData.password || !formData.nationalId) {
      setFormError('جميع الحقول المطلوبة يجب ملؤها');
      return;
    }
    setFormLoading(true);
    try {
      await workersAPI.create(formData);
      setShowForm(false);
      setFormData({ name: '', phone: '', password: '', nationalId: '', vehicleType: '', vehiclePlate: '' });
      loadAll();
    } catch (error) {
      setFormError(error.response?.data?.error || 'حدث خطأ أثناء إضافة العامل');
    } finally {
      setFormLoading(false);
    }
  };

  if (loading) return <div className="loading">جاري التحميل...</div>;

  return (
    <div>
      <div className="page-header">
        <h2>إدارة العمال</h2>
        <button className="btn btn-primary" onClick={() => setShowForm(!showForm)}>
          {showForm ? '✕ إلغاء' : '➕ إضافة عامل جديد'}
        </button>
      </div>

      {showForm && (
        <div className="card" style={{ marginBottom: 24, padding: 24 }}>
          <h3 style={{ marginBottom: 16 }}>إضافة عامل جديد</h3>
          {formError && <div style={{ background: '#fee', color: '#c00', padding: '8px 12px', borderRadius: 6, marginBottom: 12 }}>{formError}</div>}
          <form onSubmit={handleCreate}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 12 }}>
              <div>
                <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>الاسم *</label>
                <input className="form-input" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} placeholder="اسم العامل" />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>رقم الهاتف *</label>
                <input className="form-input" value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} placeholder="05xxxxxxxx" />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>كلمة المرور *</label>
                <input className="form-input" type="password" value={formData.password} onChange={(e) => setFormData({ ...formData, password: e.target.value })} placeholder="6 أحرف على الأقل" />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>رقم الهوية *</label>
                <input className="form-input" value={formData.nationalId} onChange={(e) => setFormData({ ...formData, nationalId: e.target.value })} placeholder="رقم الهوية" />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>نوع المركبة</label>
                <input className="form-input" value={formData.vehicleType} onChange={(e) => setFormData({ ...formData, vehicleType: e.target.value })} placeholder="سيارة / دراجة نارية" />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>لوحة المركبة</label>
                <input className="form-input" value={formData.vehiclePlate} onChange={(e) => setFormData({ ...formData, vehiclePlate: e.target.value })} placeholder="رقم اللوحة" />
              </div>
            </div>
            <div style={{ marginTop: 16 }}>
              <button className="btn btn-success" type="submit" disabled={formLoading}>
                {formLoading ? 'جاري الإضافة...' : '✅ إضافة العامل'}
              </button>
            </div>
          </form>
        </div>
      )}

      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        <button className={`btn ${tab === 'all' ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setTab('all')}>
          جميع العمال ({allWorkers.length})
        </button>
        <button className={`btn ${tab === 'pending' ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setTab('pending')}>
          طلبات الانضمام ({pendingWorkers.length})
        </button>
      </div>

      {tab === 'pending' && (
        pendingWorkers.length === 0 ? (
          <div className="empty-state">
            <span className="empty-icon">✅</span>
            <p>لا توجد طلبات معلقة</p>
          </div>
        ) : (
          <div className="workers-grid">
            {pendingWorkers.map((worker) => (
              <div key={worker.id} className="worker-card">
                <div className="worker-card-header">
                  <span className="worker-avatar">🔧</span>
                  <div>
                    <h3>{worker.user?.name}</h3>
                    <p>{worker.user?.phone}</p>
                  </div>
                </div>
                <div className="worker-card-body">
                  <div className="worker-info-row"><span>رقم الهوية:</span><strong>{worker.nationalId}</strong></div>
                  <div className="worker-info-row"><span>نوع المركبة:</span><strong>{worker.vehicleType}</strong></div>
                  <div className="worker-info-row"><span>لوحة المركبة:</span><strong>{worker.vehiclePlate}</strong></div>
                </div>
                <div className="worker-card-actions">
                  <button className="btn btn-success" onClick={() => handleApprove(worker.id)}>✅ قبول</button>
                  <button className="btn btn-danger" onClick={() => handleReject(worker.id)}>❌ رفض</button>
                </div>
              </div>
            ))}
          </div>
        )
      )}

      {tab === 'all' && (
        allWorkers.length === 0 ? (
          <div className="empty-state">
            <span className="empty-icon">👷</span>
            <p>لا يوجد عمال مسجلين</p>
          </div>
        ) : (
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>الاسم</th>
                  <th>الهاتف</th>
                  <th>رقم الهوية</th>
                  <th>المركبة</th>
                  <th>اللوحة</th>
                  <th>الحالة</th>
                  <th>التقييم</th>
                  <th>الطلبات المكتملة</th>
                  <th>الأرباح</th>
                </tr>
              </thead>
              <tbody>
                {allWorkers.map((worker) => (
                  <tr key={worker.id}>
                    <td>{worker.user?.name}</td>
                    <td>{worker.user?.phone}</td>
                    <td>{worker.nationalId}</td>
                    <td>{worker.vehicleType || '-'}</td>
                    <td>{worker.vehiclePlate || '-'}</td>
                    <td>
                      <span style={{
                        padding: '4px 10px', borderRadius: 12, fontSize: 13, fontWeight: 500,
                        background: worker.isApproved ? '#e8f5e9' : '#fff3e0',
                        color: worker.isApproved ? '#2e7d32' : '#e65100',
                      }}>
                        {worker.isApproved ? 'معتمد' : 'معلق'}
                      </span>
                    </td>
                    <td>⭐ {parseFloat(worker.ratingAverage || 0).toFixed(1)}</td>
                    <td>{worker.completedOrders || 0}</td>
                    <td>{parseFloat(worker.totalEarnings || 0).toFixed(0)} ج.م</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}
    </div>
  );
}
